<template>
<div>
    <Banner/>
    <div class="go-background-logo">
        <v-row justify="center" no-gutters>
            <v-col cols="11">
                <v-spacer class="row-space-30"></v-spacer>
                <v-row class="become-a-go-scholar" justify="center">WELCOME TO GO</v-row>
                    <v-spacer class="row-space-30"></v-spacer>
                    <v-row justify="center" no-gutters>
                        <v-col cols="10" class="to-start-the-process">
                            <div style="margin:auto">
                            To get started, choose what type of scholarship you want to apply for.
                            </div>
                        </v-col>
                    </v-row>
                    <v-spacer class="row-space-30"></v-spacer>
                <v-col justify="center" no-gutters>
                    <v-row justify="center" no-gutters>
                        <v-col cols="10" sm="8" md="5" lg="4">
                            <v-row class="square" justify="center" style="margin:auto">
                                <v-col cols="10" style="text-align: center;padding:40px 20px">
                                    <img :src=Primary class="choice"/> 
                                    <p class="become-a-go-scholar" style="font-size:20px;margin:20px;letter-spacing:1px;">PRIMARY SCHOOL </p> 
                                    <v-btn @click="goPrimary()" height="53" style="width:100%; max-width:384px;" color="#ea7f1d" class="btn-add centre-aligned">
                                        <span class="btn-font" >Apply</span>
                                    </v-btn>              
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="10" sm="8" md="5" lg="4">
                            <v-row class="square" justify="center" style="margin:auto">
                                <v-col cols="10" style="text-align: center;padding:40px 20px">
                                    <img :src=High class="choice"/> 
                                    <p class="become-a-go-scholar" style="font-size:20px;margin:20px;letter-spacing:1px;">HIGH SCHOOL</p> 
                                    <v-btn @click="goButtonClicked()" height="53" style="width:100%; max-width:384px;" color="#d05927" class="btn-add centre-aligned">
                                        <span class="btn-font" >Apply</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="10" sm="8" md="5" lg="4">
                            <v-row class="square" justify="center" style="margin:auto">
                                <v-col cols="10" style="text-align: center;padding:40px 20px">
                                    <img :src=Uni class="choice"/> 
                                    <p class="become-a-go-scholar" style="font-size:20px;margin:20px;letter-spacing:1px;">UNIVERSITY</p> 
                                    <v-btn height="53" style="width:100%; max-width:384px;" color="#b11116" class="btn-add centre-aligned">
                                        <span class="btn-font" >Apply</span>
                                    </v-btn>              
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-col>
        </v-row>
        
    </div>
    
</div>
</template>
<script>

import LandingPrimary from "../../public/Landingprimary.png";
import LandingHigh from "../../public/Landinghigh.png";
import LandingUni from "../../public/Landinguni.png";
import Banner from './BannerComponent.vue'
//import highschool from "../../public/highschool.svg";
//import primary from "../../public/primary.svg";
//import university from "../../public/university.svg";


export default {
    components: {        
        //LandingHigh,
        //primary,
        //highschool,
        //university,
        Banner,
    },  
    data(){
        return{
            High:LandingHigh,
            Primary:LandingPrimary,
            Uni:LandingUni
        }
    },
    methods:{
        goButtonClicked: function(){
            this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'high'});
            // window.location.href = '/welcome/eligibility/1'
            this.$router.push({
                name: 'eligibility.0'
            });

        },
        goPrimary: function(){
            this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'primary'});
            this.$router.push({
                name: 'eligibility.0'
            });
        }
    },
    

    
}
</script>
<style scoped>
.become-a-go-scholar{
  font-family: Dosis;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 4px;
  color: black;
  margin: 0 auto;
  text-align: center;
}

.btn-add
{
    border-radius: 3px;
}

.btn-font {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #ffffff;
}

.to-start-the-process 
{
    max-width:1200px;
    font-family: Hind;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align:center;
    color: black
}

.to-start-the-process .text-style-1 {
  color: #ea7f1d;
}

.row-space-40
{
    height: 40px;
}

.row-space-30
{
    height: 30px
}
.go-background-logo
{
    background-image: url(/go-logo-tilt.svg);
    width: 100%;
    min-height: 700px;
    background-position-y: 185px;
    background-attachment: fixed;
    background-size: 610px;
    padding-bottom: 100px;
}
.square
{
    width: 300px;
    height: 300px;
    border: solid 1px #a5a5a5;
    background-color: #ffffff;
}
.choice
{
    height:120px;
}
</style>